import { Form } from 'antd';
import { SelectProps } from 'antd/lib';
import { FormInstance } from 'antd/lib/form';
import { useMemo, useState } from 'react';

import { Technician } from '@/model/General/Technician';
import { SERVICE_ORDER_TYPE } from '@/model/ServiceOrder/ServiceOrder';

/**
 * Hook que gestiona la selección de técnico y el cálculo
 * de la función para asignar precios según tipo de servicio.
 */
const useTechnicianPricing = (
  form: FormInstance | undefined,
  technicianSelectPropsWithInitials: SelectProps & { onSelect?: any },
  initialTechnician?: Technician | null,
) => {
  const [selectedTechnician, setSelectedTechnician] = useState<Technician | null>(
    initialTechnician ?? null,
  );
  const serviceType = Form.useWatch('type', form);
  // Wrapper del selectProps para capturar el técnico seleccionado
  const modifiedTechnicianSelectProps = useMemo(() => {
    return {
      ...technicianSelectPropsWithInitials,
      onSelect: (value: any, option: any) => {
        const technicianItem = option.item as Technician;

        setSelectedTechnician(technicianItem);

        if (technicianSelectPropsWithInitials.onSelect) {
          technicianSelectPropsWithInitials.onSelect(value, option);
        }
      },
    };
  }, [technicianSelectPropsWithInitials]);
  // Genera la función para asignar precios del técnico al formulario
  const assignTechnicianPrice = useMemo(() => {
    if (!selectedTechnician) {
      return undefined;
    }

    const { external_hour_price, external_km_price, moneda } = selectedTechnician;

    if (!moneda) {
      return undefined;
    }

    if (serviceType == SERVICE_ORDER_TYPE.INSTALACION) {
      return undefined;
    } else {
      if (external_hour_price || external_km_price) {
        return () => {
          form?.setFieldsValue({
            currency: moneda.id,
            hourly_rate: external_hour_price,
            kilometres_rate: external_km_price,
          });
        };
      }
    }

    return undefined;
  }, [form, selectedTechnician, serviceType]);

  return {
    modifiedTechnicianSelectProps,
    assignTechnicianPrice,
    selectedTechnician,
  };
};

export default useTechnicianPricing;
